
    import HeadingWave from "@/features/shared/components/HeadingWave.vue";
    import Component from "vue-class-component";
    import Vue from "vue";
    import ApplicationsTable from "@/features/applications/components/ApplicationsTable.vue";

    @Component({
        components: {
            HeadingWave,
            ApplicationsTable
        }
    })
    export default class OfficialDashboard extends Vue {
    }
